import { notesPendingActionActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [notesPendingActionActions.loadSuccess]: (state, action) => {
        let result;
        action.payload.entities.notesPendingAction ? result = action.payload.entities.notesPendingAction : result = {};
        return result;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        let result;
        action.payload.notesPendingAction.entities.notesPendingAction ? result = action.payload.notesPendingAction.entities.notesPendingAction : result = {};
        return result;
    },
    [notesPendingActionActions.deleteAllSuccess]: (state, action) => {
        let result;
        action.payload.entities.notesPendingAction ? result = action.payload.entities.notesPendingAction : result = {};
        return result;
    },
    [notesPendingActionActions.markReadSuccess]: (state, action) => {
        state[action.payload].isRead = true;
    },
    [notesPendingActionActions.deleteSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.NONO === action.payload.nono) {
                delete state[x.id];
            }
        })
    },
})


